import type {Endpoints} from "@hosttools/web/server/routes/routes.locks.types";
import type {AxiosInstance} from "axios";

import type {Lock} from "../../models/lock";

class LockService {
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    async saveLock(lock: Lock, pinLength?: number, removingListingIDs?: string[]): Promise<void> {
        const request: Endpoints["/editLockSettings"]["reqBody"] = {
            lockID: lock._id,
            nickname: lock.nickname?.trim() || "",
            checkInBuffer: lock.checkInBuffer || 0,
            checkOutBuffer: lock.checkOutBuffer || 0,
            pinLength: pinLength || 0,
            removingListingIDs: removingListingIDs || []
        };
        await this.http.post<Endpoints["/editLockSettings"]["resBody"]>(
            "/editLockSettings",
            request
        );
    }

    async deleteLock(lockID: string): Promise<void> {
        const request: Endpoints["/deleteLock"]["reqBody"] = {lockID};
        await this.http.delete<Endpoints["/deleteLock"]["resBody"]>("/deleteLock", {
            data: request
        });
    }

    async getLockStatus(lockID: string): Promise<Endpoints["/lock/:lockId/status"]["resBody"]> {
        const response = await this.http.get<Endpoints["/lock/:lockId/status"]["resBody"]>(
            `/lock/${lockID}/status`
        );
        return response.data;
    }

    async controlLock(
        lockID: string,
        action: "lock" | "unlock"
    ): Promise<Endpoints["/lock/:lockId/control"]["resBody"]> {
        const request: Endpoints["/lock/:lockId/control"]["reqBody"] = {action};
        const response = await this.http.post<Endpoints["/lock/:lockId/control"]["resBody"]>(
            `/lock/${lockID}/control`,
            request
        );
        return response.data;
    }
}

export default LockService;
